"use client"
import { Link } from "react-router-dom"
import Footer from "./Footer"

const HowItWorks = () => {
  return (
    <div className="how-it-works-page">
      {/* Hero Section */}
      <section className="how-it-works-hero">
        <div className="how-it-works-hero-container">
          <h1 className="how-it-works-hero-title">How Shopify Scraper Works</h1>
          <p className="how-it-works-hero-description">A simple guide to using our powerful product extraction tool</p>
        </div>
      </section>

      {/* Steps Section */}
      <section className="steps-section">
        <div className="steps-container">
          <div className="step-card">
            <div className="step-number">1</div>
            <div className="step-content">
              <h2 className="step-title">Install the Chrome Extension</h2>
              <p className="step-description">
                Download and install our Chrome extension from the Chrome Web Store. The extension is lightweight and
                installs in seconds.
              </p>
              {/* <img
                src="https://via.placeholder.com/600x350/00a99d/FFFFFF?text=Install+Chrome+Extension"
                alt="Install Chrome Extension"
                className="step-image"
              /> */}
              <Link to="/home" className="step-button">
                Try It Now
              </Link>
            </div>
          </div>

          <div className="step-card">
            <div className="step-number">2</div>
            <div className="step-content">
              <h2 className="step-title">Visit Any Shopify Store</h2>
              <p className="step-description">
                Navigate to any Shopify store you want to extract data from. Our extension automatically detects Shopify
                stores and activates.
              </p>
              {/* <img
                src="https://via.placeholder.com/600x350/00a99d/FFFFFF?text=Visit+Shopify+Store"
                alt="Visit Shopify Store"
                className="step-image"
              /> */}
            </div>
          </div>

          <div className="step-card">
            <div className="step-number">3</div>
            <div className="step-content">
              <h2 className="step-title">Click the Extension Icon</h2>
              <p className="step-description">
                Click on the Shopify Scraper icon in your browser toolbar. This will open the extension popup with
                available options.
              </p>
              {/* <img
                src="https://via.placeholder.com/600x350/00a99d/FFFFFF?text=Click+Extension+Icon"
                alt="Click Extension Icon"
                className="step-image"
              /> */}
            </div>
          </div>

          <div className="step-card">
            <div className="step-number">4</div>
            <div className="step-content">
              <h2 className="step-title">Choose Export Options</h2>
              <p className="step-description">
                Select whether you want to export all products or specific collections. You can also choose the export
                format and customize fields.
              </p>
              {/* <img
                src="https://via.placeholder.com/600x350/00a99d/FFFFFF?text=Choose+Export+Options"
                alt="Choose Export Options"
                className="step-image"
              /> */}
            </div>
          </div>

          <div className="step-card">
            <div className="step-number">5</div>
            <div className="step-content">
              <h2 className="step-title">Extract and Download</h2>
              <p className="step-description">
                Click the "Extract Products" button and wait for the process to complete. Once finished, download your
                CSV file with all the product data.
              </p>
              {/* <img
                src="https://via.placeholder.com/600x350/00a99d/FFFFFF?text=Extract+and+Download"
                alt="Extract and Download"
                className="step-image"
              /> */}
            </div>
          </div>
        </div>
      </section>

      {/* Features Overview */}
      <section className="features-overview-section">
        <div className="features-overview-container">
          <h2 className="features-overview-title">Key Features</h2>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">⚡</div>
              <h3 className="feature-title">Lightning Fast</h3>
              <p className="feature-description">
                Extract hundreds of products in seconds with our optimized algorithms
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🔍</div>
              <h3 className="feature-title">Advanced Filtering</h3>
              <p className="feature-description">Filter products by collection, price range, or specific criteria</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">📊</div>
              <h3 className="feature-title">Complete Data</h3>
              <p className="feature-description">Get titles, descriptions, images, prices, variants, and more</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">📁</div>
              <h3 className="feature-title">CSV Export</h3>
              <p className="feature-description">Download data in CSV format compatible with Shopify and WooCommerce</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🔒</div>
              <h3 className="feature-title">Secure & Private</h3>
              <p className="feature-description">Your data is securely stored and accessible only to you</p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">🔄</div>
              <h3 className="feature-title">Regular Updates</h3>
              <p className="feature-description">We continuously improve the extension with new features</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="how-it-works-cta-section">
        <div className="how-it-works-cta-container">
          <h2 className="how-it-works-cta-title">Ready to get started?</h2>
          <p className="how-it-works-cta-description">
            Download the Shopify Scraper extension and start extracting product data in minutes
          </p>
          <div className="how-it-works-cta-buttons">
            <Link to="/home" className="how-it-works-cta-button primary">
              Try It Now
            </Link>
            <Link to="/pricing" className="how-it-works-cta-button secondary">
              View Pricing Plans
            </Link>
          </div>
        </div>
      </section>


      {/* Styling */}
      <style jsx="true">{`
        /* How It Works Hero Section */
        .how-it-works-hero {
          background-color: #007BFF;
          color: white;
          padding: 5rem 0;
          text-align: center;
        }
        
        .how-it-works-hero-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        
        .how-it-works-hero-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
        }
        
        .how-it-works-hero-description {
          font-size: 1.25rem;
          max-width: 800px;
          margin: 0 auto;
          opacity: 0.9;
        }
        
        /* Steps Section */
        .steps-section {
          padding: 5rem 0;
          background-color: #f9fafb;
        }
        
        .steps-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          flex-direction: column;
          gap: 3rem;
        }
        
        .step-card {
          background-color: white;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          padding: 2rem;
          display: flex;
          gap: 2rem;
        }
        
        .step-number {
          width: 4rem;
          height: 4rem;
          background-color: #007BFF;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          font-weight: 700;
          flex-shrink: 0;
        }
        
        .step-content {
          flex: 1;
        }
        
        .step-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #1a202c;
        }
        
        .step-description {
          margin-bottom: 1.5rem;
          color: #4a5568;
          line-height: 1.6;
        }
        
        .step-image {
          width: 100%;
          max-width: 400px;
          height: auto;
          border-radius: 0.375rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        .step-button {
          display: inline-block;
          background-color: #007BFF;
          color: white;
          font-weight: 600;
          padding: 0.75rem 1.5rem;
          border-radius: 0.375rem;
          text-decoration: none;
          transition: background-color 0.2s;
        }
        
        .step-button:hover {
          background-color: #008f85;
        }
        
        /* Features Overview */
        .features-overview-section {
          padding: 5rem 0;
          background-color: white;
        }
        
        .features-overview-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        
        .features-overview-title {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 3rem;
          text-align: center;
          color: #1a202c;
        }
        
        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 2rem;
        }
        
        .feature-item {
          background-color: #f9fafb;
          padding: 2rem;
          border-radius: 0.5rem;
          text-align: center;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .feature-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        }
        
        .feature-icon {
          font-size: 2.5rem;
          margin-bottom: 1.5rem;
        }
        
        .feature-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #1a202c;
        }
        
        .feature-description {
          color: #4a5568;
          line-height: 1.6;
        }
        
        /* CTA Section */
        .how-it-works-cta-section {
          padding: 5rem 0;
          background-color: #007BFF;
          color: white;
          text-align: center;
        }
        
        .how-it-works-cta-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }
        
        .how-it-works-cta-title {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        
        .how-it-works-cta-description {
          font-size: 1.125rem;
          margin-bottom: 2rem;
          opacity: 0.9;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }
        
        .how-it-works-cta-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        
        .how-it-works-cta-button {
          padding: 0.75rem 1.5rem;
          border-radius: 0.375rem;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.2s;
        }
        
        .how-it-works-cta-button.primary {
          background-color: white;
          color: #007BFF;
        }
        
        .how-it-works-cta-button.primary:hover {
          background-color: #f9fafb;
        }
        
        .how-it-works-cta-button.secondary {
          background-color: transparent;
          border: 2px solid white;
          color: white;
        }
        
        .how-it-works-cta-button.secondary:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        /* Responsive Styles */
        @media (max-width: 1024px) {
          .step-card {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          
          .step-number {
            margin-bottom: 1rem;
          }
        }
        
        @media (max-width: 768px) {
          .how-it-works-hero-title {
            font-size: 2rem;
          }
          
          .how-it-works-hero-description {
            font-size: 1.125rem;
          }
          
          .features-overview-title, .how-it-works-cta-title {
            font-size: 1.75rem;
          }
        }
      `}</style>
    </div>
  )
}

export default HowItWorks
